<template>
  <div>
    <b-card>

      <div
        class="mb-3"
        style="display: flex; justify-content: space-between; border-bottom: 1px solid #f5f6f9; padding-bottom: 1rem"
      >
        <!-- {{ paymentMethods }} <br/>
        {{paymentMethods.toString()}} -->
        <div v-if="fundraiserData" style="font-size: 18px; color: #5E5873;">
          {{ fundraiserData.title }}
        </div>
        <div>
          <feather-icon
            icon="EditIcon"
            size="20"
            style="cursor: pointer"
          />
        </div>
      </div>
      <hr>

      <b-row
        class="justify-content-center align-center"
        align-content="center"
      >
        <b-col md="8">
          <b-form
            class="my-3"
            @submit.prevent="updatePaymentMethods()"
          >
            <b-form-group
              class="pt-2"
              label="Select all relevant payment methods and click the update button"
            >
              <b-form-checkbox-group
                id="checkbox-group-1"
                v-model="paymentMethods"
                class=" "
                :options="options"
                stacked

                name="paymentmethods"
              />
            </b-form-group>

            <b-button
              type="submit"
              :disabled="loading"
              variant="primary"
              class="mt-3"
            >
              <b-spinner v-if="loading" />
              <span v-else>Update Payment Method</span>
            </b-button>
          </b-form>

        </b-col>
      </b-row>

    </b-card>
  </div>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { savePaymentMethods, getFundDetails } from '@/service/api.service'
import {
  BCard, BForm, BFormGroup, BFormCheckboxGroup, BRow, BCol, BButton, BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BCard, BForm, BFormGroup, BFormCheckboxGroup, BRow, BCol, BButton, BSpinner,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    fundraiserId: {
      type: String,
    },
  },
  data() {
    return {
      fundraiserData: null,
      paymentMethods: [],

      loading: false,
      options: [
        { text: 'Monnify Bank Transer', value: '1' },
        { text: 'Paystack Card', value: '2' },
        { text: 'Paystack Apple Pay', value: '3' },
        { text: 'Paystack Google Pay', value: '4' },
        { text: 'Monnify Card', value: '5' },
        { text: 'Monnify USSD', value: '6' },
        { text: 'Monnify Cash', value: '7' },
        { text: 'Crowdforce NQR', value: '8' },
        { text: 'Flutterwave Card', value: '9' },
        { text: 'Flutterwave Apple Pay (NGN)', value: '10' },
        { text: 'Flutterwave Google Pay (NGN)', value: '11' },
        { text: 'Flutterwave Apple Pay (USD)', value: '12' },
        { text: 'Flutterwave Google Pay (USD)', value: '13' },
        { text: 'CoralPay USSD', value: '14' },
        { text: 'Bachs Crypto', value: '15' },
        { text: 'Bachs Card', value: '16' },
      ],
    }
  },
  async created() {
    await this.getFundraiserDetails()
  },
  methods: {
    getFundraiserDetails() {
      this.loading = true
      // eslint-disable-next-line no-undef
      getFundDetails(this.fundraiserId)
        .then(res => res.json())
        .then(response => {
          this.loading = false
          if (response.valid) {
            this.fundraiserData = response.data
            this.paymentMethods = String(this.fundraiserData.supportedPayments || '').split(',').map(value => value.trim()).filter(Boolean)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    updatePaymentMethods() {
      this.loading = true
      savePaymentMethods(this.fundraiserId, {
        supportedPayments: this.paymentMethods.toString(),
      })
        .then(res => res.json())
        .then(response => {
          this.loading = false

          if (response.valid) {
            this.showToast(
              'Success',
              'success',
              'Payment methods updated successfully!',
            )
          }
        }).catch(e => {
          this.loading = false
          this.showToast('Error', 'danger', e)
        })
    },
    showToast(title, variant, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          text,
          icon: title === 'Error' ? 'TrashIcon' : 'DoneIcon',
          variant,
        },
      })
    },

  },
}
</script>

<style>

</style>
